<template>
  <div class="player-container-class">
    <div class="prism-player">
      <div ref="playerTemp"></div>
    </div>
  </div>
</template>
<script>
//2.16.3
// require('https://g.alicdn.com/apsara-media-box/imp-web-player/2.16.3/aliplayer-min.js')
export default {
  // 在vue中怎么使用Aliplayer
  name: 'Aliplayer',
  props: {
    url: {
      type: String,
      default: undefined
    },
    type: {
      type: String,
      default: 'm3u8'
    }
  },
  data() {
    return {
      reading: false,
      scriptTagStatus: 0,
      isReload: false,
      player: null,
      width: '100%',
      height: '100px',
      autoplay: false
    };
  },
  watch: {
    url(val) {
      if (!this.player) {
        // 如果全局对象存在，说明编辑器代码已经初始化完成，直接加载编辑器
        this.initPlayer(val);
      } else {
        // 如果全局对象不存在，说明编辑器代码还没有加载完成，需要加载编辑器代码
        this.player.loadByUrl(val);
      }
    }
  },
  methods: {
    initPlayer() {
      if (document.getElementById('player-con') === null) {
        let playerDomWrap = this.$refs.playerTemp;
        let playerDom = document.createElement('div');
        playerDom.setAttribute('id', 'player-con');
        playerDom.setAttribute('style', 'width:100%;height:100%;');
        playerDomWrap.appendChild(playerDom);
      } else {
        this.player.dispose();
      }

      let config = {
        id: 'player-con',
        source: this.url,
        isLive: false,
        // cover: cover, 图片
      }
      // eslint-disable-next-line no-undef
      this.player = new Aliplayer(config);

      this.player.on('ready', () => {
        this.$emit('ready', this.player);
        this.player.on('play', () => {
          this.$emit('play', this.player);
        });
        this.player.on('pause', () => {
          this.$emit('pause', this.player);
        });
        this.player.on('ended', () => {
          this.$emit('ended', this.player);
        });
        this.player.on('liveStreamStop', () => {
          this.$emit('liveStreamStop', this.player);
        });
        this.player.on('m3u8Retry', () => {
          this.$emit('m3u8Retry', this.player);
        });
        this.player.on('hideBar', () => {
          this.$emit('hideBar', this.player);
        });
        this.player.on('waiting', () => {
          this.$emit('waiting', this.player);
        });
        this.player.on('snapshoted', () => {
          this.$emit('snapshoted', this.player);
        });

        this.player.on('timeupdate', () => {
          this.$emit('timeupdate', this.player);
        });
        this.player.on('requestFullScreen', () => {
          this.$emit('requestFullScreen', this.player);
        });
        this.player.on('cancelFullScreen', () => {
          this.$emit('cancelFullScreen', this.player);
        });
        this.player.on('error', () => {
          this.$emit('error', this.player);
        });
        this.player.on('startSeek', () => {
          this.$emit('startSeek', this.player);
        });
        this.player.on('completeSeek', () => {
          this.$emit('completeSeek', this.player);
        });
      })

    },
    /**
     * 播放视频
     */
    play: function () {
      this.player.play();
    },
    /**
     * 暂停视频
     */
    pause: function () {
      this.player.pause();
    },
    /**
     * 重播视频
     */
    replay: function () {
      this.player.replay();
    },
    /**
     * 跳转到某个时刻进行播放
     * @argument time 的单位为秒
     */
    seek: function (time) {
      this.player.seek(time);
    },
    getStatus() {
      return this.player.getStatus();
    },
    /**
     * 获取当前时间 单位秒
     */
    getCurrentTime: function () {
      return this.player.getCurrentTime();
    },
    /**
     *获取视频总时长，返回的单位为秒
     * @returns 返回的单位为秒
     */
    getDuration: function () {
      return this.player.getDuration();
    },
    /**
     获取当前的音量，返回值为0-1的实数ios和部分android会失效
     */
    getVolume: function () {
      return this.player.getVolume();
    },
    /**
     设置音量，vol为0-1的实数，ios和部分android会失效
     */
    setVolume: function (vol) {
      this.player.setVolume(vol);
    },
    /**
     *直接播放视频url，time为可选值（单位秒）目前只支持同种格式（mp4/flv/m3u8）之间切换暂不支持直播rtmp流切换
     *@argument url 视频地址
     *@argument time 跳转到多少秒
     */
    // loadByUrl: function (url, time) {
    //   this.player.loadByUrl(url, time);
    // },
    //
    // loadByUrl: function (url, time) {
    //   this.player.loadByUrl(url, time);
    // },
    //
    /**
     * 设置播放速度
     *@argument speed 速度
     */
    setSpeed: function (speed) {
      this.player.setSpeed(speed);
    },
    /**
     * 设置播放器大小w,h可分别为400px像素或60%百分比chrome浏览器下flash播放器分别不能小于397x297
     *@argument w 播放器宽度
     *@argument h 播放器高度
     */
    setPlayerSize: function (w, h) {
      this.player.setPlayerSize(w, h);
    },
    /**
     * 目前只支持HTML5界面上的重载功能,暂不支持直播rtmp流切换m3u8）之间切换,暂不支持直播rtmp流切换
     *@argument vid 视频id
     *@argument playauth 播放凭证
     */
    reloaduserPlayInfoAndVidRequestMts: function (vid, playauth) {
      this.player.reloaduserPlayInfoAndVidRequestMts(vid, playauth);
    },

  },
  beforeDestroy() {
    console.log('销毁播放器!');
    if (this.player) {
      this.player.dispose();
    }
  }
};
</script>
<style scoped>
@import 'https://g.alicdn.com/apsara-media-box/imp-web-player/2.16.3/skins/default/aliplayer-min.css';

.prism-player {
  z-index: 1;
  width: 100%;
  height: 100%;
}

.player-container-class {
  width: 100%;
  height: 100%;
}

.prism-player > div {
  height: 100%;
}

#player-con {
  height: 100%;
}
</style>
